import { PlaceholderValue } from "./PlaceholderValue";
import { type AggregatorListItem } from "./types";
import { getAggregatorName } from "./utils";

const NameCell = ({ aggregator }: { aggregator: AggregatorListItem }) => (
  <div className="min-w-0 whitespace-normal wrap-break-words font-medium text-foreground">
    {getAggregatorName(aggregator) || <PlaceholderValue />}
  </div>
);

export { NameCell };
